/* global localStorage */

import axios from 'axios'

const API_URL = 'https://vrc.api.maxis.io/v1/'

export default axios.create({
  baseURL: API_URL,
  headers: {
    'apikey': 'MTMzN2JveGx1bmNoc2FsYWQ=',
    'Content-Type': 'application/json',
    'From-App': 'VSS WebPanel'
  }
})



// WEBPACK FOOTER //
// ./src/backend/vue-axios/axios.js